// extracted by mini-css-extract-plugin
export default {"transition":"transition_transition__7mTA3","transition_link":"transition_transition_link__NVQJN"};